const keysToMatch = [
  'name',
  'headquarters',
  'foundedYear',
  'employeeCount',
  'revenue',
  'marketingBudget',
  'primaryIndustry',
  'ticker',
  'ceo',
  'phone',
  'domainRank',
  'socialMediaUrls',
];

export const formatKeysToDisplay = (data: any) =>
  Object.keys(data).filter((k) => keysToMatch.includes(k));
